import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from 'store/types/TStore';

export const selfMaterialAssessmentManagement = (state: RootState) => state.materialAssessment;

export const selectMaterialAssessments = createSelector(
  [selfMaterialAssessmentManagement],
  ({ materialAssessments }) => materialAssessments,
);

export const selectMaterialId = createSelector(
  [selfMaterialAssessmentManagement],
  ({ materialId }) => materialId,
);
